export default "__VITE_ASSET__IotIkPBV__"